const apiBaseUrl = (systemName: string): string =>
  systemName === 'admin'
    ? 'https://api.dev.assortment.leafio.app'
    : `https://api.${systemName}.dev.assortment.leafio.app`;

export const environment = {
  production: false,
  apiUrl: (systemName: string) =>
    `${apiBaseUrl(systemName)}/login`,
  invitationApiUrl: (systemName: string) =>
    `${apiBaseUrl(systemName)}/api/invitation`,
  ssoApiUrl: (systemName: string) =>
    `${apiBaseUrl(systemName)}/api/sso_session`,
  baseDomain: 'dev.assortment.leafio.app',
};
